import React from "react";
import { Bar } from 'react-chartjs-2';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';

  import "chartjs-plugin-datalabels";
  import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from "chart.js";
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  import 'chart.js/auto';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels // Register the DataLabels plugin
  );
  

  const BarChartSubquestions = (props) => {
const { t } = useTranslation();
    
  const options = {
  responsive: true,
   maintainAspectRatio: false,
   layout: {
      padding: {
        top: 32,
       
     
  
      }
    },
   scales: {
    x: {
        display: true,
       
    },
          y: {
        display: true,
        position: "left",
        title: {
          display: true,
          text: t(props.titleY),
        
           color: "rgb(84, 84, 84)", 
            font: {
              size: 13,
              weight: "500",
            },
        },
         padding: {top: 50, left: 0, right: 0, bottom: 0}
      }
    },
  plugins: {
 
    legend: {
      display: true,
      position: "bottom",
      align: "center",
          onClick: null

     
      
    },
    title: {
      display: true,
        align:'start',
        text: props.titleX,
      position:'bottom',
       color: "rgb(84, 84, 84)", 
            font: {
              size: 10,
              weight: "500",
            },
    },
      datalabels: {
          align: 'end',
            anchor: 'end',
            color: "black", 
            font: {
              size: 14,
              weight: "500",
            },
  },
},

  };


const labels = [""];
const datasets = [];
const colors = 
props.data.length === 8 ? ["rgb(160, 203, 232)", "rgb(176, 122, 161)", "rgb(242, 142, 43)", "rgb(78, 121, 167)","rgb(121, 112, 110)","rgb(216, 181, 166)", "rgb(182, 153, 45)", "rgb(169, 181, 173)"] :
props.data.length === 5 ?  
      ["rgb(160, 203, 232)", "rgb(176, 122, 161)", "rgb(242, 142, 43)", "rgb(78, 121, 167)","rgb(121, 112, 110)" ] :
      ["rgb(160, 203, 232)", "rgb(176, 122, 161)", "rgb(242, 142, 43)","rgb(121, 112, 110)" ];

props.data.forEach((elem, index) => {datasets.push({label: t(props.label[index]).replace(/[ ,.]/g,' '), 
  data:[elem], backgroundColor: colors[index]})});


const dataSet = {
  labels,
  datasets: datasets
};
    return (
      <div >
      <Card className="card-padding-always">
      <Card.Header className="container-header" >
        <p className="vertical-center card-title" >{t(props.graphTitle)}</p></Card.Header>
      <Card.Body > 
        <div className="graph-div-main">
         <Bar options={options} data={dataSet} className="graph-height-mobile"/>
         </div>
       </Card.Body>
    </Card> 


   
      </div>
    );
  };
  
  export default BarChartSubquestions;
  
